module.exports = __webpack_public_path__ + "img/living-tag.0bbc002b.gif";